import { makeStyles } from "@material-ui/core/styles";
const drawerWidth = 235;

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        background: "#FFF",
    },
    appBar: {
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        background: "#FFF",
        boxShadow: "none",
        color: "rgba(0, 0, 0, 0.87)",
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        borderTopLeftRadius: "5px",
    },
    title: {
        flexGrow: 1,
        marginBottom: "15px",
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: "none",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        zIndex: 9,
    },
    drawerPaper: {
        width: drawerWidth,
        background: "#2490ff",
        color: "#FFF",
    },
    drawerHeader: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: "flex-end",
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
        height: "100%",
        overflow: "auto",
    },
    contentShift: {
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
        zIndex: 10,
        borderRadius: "5px",
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    speedDial: {
        position: "absolute",
        "&.MuiSpeedDial-directionUp": {
            bottom: theme.spacing(2),
            right: theme.spacing(2),
        },
    },
    gridList: {
        width: "100%",
        minHeight: "200px",
        overflow: "auto",
        maxHeight: "300px",
    },
    gridListRoot: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-around",
        overflow: "hidden",
        backgroundColor: theme.palette.background.paper,
    },
    formControl: {
        flexGrow: 1,
        marginLeft: "5px",
    },
    titleBar: {
        background: "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, " + "rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
    },
    resultsPopper: {
        width: "40vw",
        zIndex: 9999,
        maxHeight: "300px",
        overflow: "auto",
        boxShadow:
            "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
    },
    sortableHelper: {
        zIndex: 1000,
    },
}));

export default useStyles;
